import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { LoomOverlayTemplate } from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";
import {
    Headings,
    SitesAreSharedSpacesText,
    WelcomeBackText
} from "../../components";

export const LoggedInLoomExistingSitesUser = () => (
    <LoomOverlayTemplate size="sm">
        <Content />
    </LoomOverlayTemplate>
);

const Content = () => {
    const { formatMessage } = useIntl();

    return (
        <>
            <Headings
                main={<WelcomeBackText />}
                sub={<SitesAreSharedSpacesText />}
            />
            <SiteActivation />
            <footer css={footerCss}>
                {formatMessage({
                    id: "JiraSoftwarePageTemplate.loggedInHero.recatcha",
                    defaultMessage:
                        "This page is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply."
                })}
            </footer>
        </>
    );
};

const footerCss = css({
    fontSize: 12,
    fontWeight: 400,
    margin: 0,
    fontFamily: "Charlie Text"
});
